import React from 'react';
import edit from '../../../../static/icons/edit.svg';
import trash from '../../../../static/icons/trash.svg';
import CellTrigger from '../../Menu/MenuTriggers/CellTrigger';
import { RootState } from '../../../../state/store/store';
import { connect } from 'react-redux';
import { company } from '../../../../models/entities/company/company';
import Menu from '../../Menu/Menu';
import MenuItem from '../../Menu/MenuItem';
import { singleCompanySelectors } from '../../../../state/ducks/singleCompany/selectors';
type onRowMoreOptionClickType = () => void;
type deleteCompanyAddressType = (companyId: string, addressId: string) => void;
type Props = {
    entityId: string;
    localization: any;
    onRowMoreOptionsClick?: onRowMoreOptionClickType;
    deleteCompanyAddress: deleteCompanyAddressType;
    company?: company;
};

const CompanyAddressMenu = ({ entityId, company, localization, onRowMoreOptionsClick, deleteCompanyAddress }: Props) => {
    const menuItems = [
        <MenuItem onClick={() => onRowMoreOptionsClick && onRowMoreOptionsClick()} icon={edit} text={localization.edit} />,
        <MenuItem onClick={() => company && deleteCompanyAddress(company.id, entityId)} icon={trash} text={localization.delete} />
    ];

    return <Menu options={menuItems} MenuTrigger={CellTrigger} strStyle="display: flex;align-items: center;width: 100%;height: 100%;" />;
};

const mapStateToProps = (state: RootState) => ({
    company: singleCompanySelectors.company(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    deleteCompanyAddress: (companyId: string, addressId: string) => dispatch.companeis.deleteCompanyAddress({ companyId, addressId }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAddressMenu);
